


















































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import Widget from "@/shared/components/Widget.vue";

@Component({
  components: {
    Widget
  }
})
export default class ContributionPlannerSideBar extends Vue {
  learnMore (): void {
    this.$emit("learnMore");
  }
}
